import {MonthArray} from 'utils/constant'

export const getPreparedMonthArray = () => {
  return MonthArray.map((month) => ({
    ...month,
    label: month.label.length > 4 ? month.label.slice(0, 3) : month.label
  }))
}
